<kt-portlet class="edit-doctor-div">
  <kt-portlet-header
    [title]="getTitle() | translate"
    [viewLoading$]="loading$"
    class="cards-inside-doctor-form card-head-lg card-head"
  >
  
    <ng-container ktPortletTools class="cards-inside-doctor-form">
      <a
        ktBackButton
        class="btn btn-secondary mr-2"
        mat-raised-button
        matTooltip="{{ 'AUTH.INPUT.BACK' | translate }}"
      >
        <i class="la la-arrow-left"></i>
        <span class="hidden-mobile"> {{ 'AUTH.INPUT.BACK' | translate }}</span>
      </a>
      <a
        href="javascript:;"
        *ngIf="insurance && !insurance.id"
        class="btn btn-secondary mr-2"
        (click)="reset()"
        [disabled]="selectedTab !== 0"
        mat-raised-button
        matTooltip="{{ 'AUTH.RESET.BUTTON' | translate }}"
      >
        <i class="la la-cog"></i>
        <span class="hidden-mobile">{{ 'AUTH.RESET.BUTTON' | translate }}</span>
      </a>
      <a
        href="javascript:;"
        class="btn btn-primary mr-2"
        color="primary"
        (click)="onSumbit()"
        mat-raised-button
        matTooltip="Save & Continue"
      >
        <span class="hidden-mobile"> {{ 'AUTH.INPUT.SAVE' | translate }}</span>
      </a>
    </ng-container>
  </kt-portlet-header>

  <mat-tab-group [(selectedIndex)]="selectedTab">
    <mat-tab>
      <ng-template mat-tab-label>
        <i class="mat-tab-label-icon fa fa-info"></i>
        {{ 'AUTH.INPUT.BASIC_INFO' | translate }}
      </ng-template>
      <ng-template matTabContent>
        <div *ngIf="insurance">
          <form [formGroup]="insuranceForm" class="form form-group-seperator-dashed">
            <kt-alert
              *ngIf="hasFormErrors"
              type="warn"
              [showCloseButton]="true"
              [duration]="10000"
              (closeAl)="onAlertClose()"
            >
              {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
            </kt-alert>
            <kt-alert
              *ngIf="hasSubmissionErrors && !hasFormErrors"
              type="warn"
              [duration]="30000"
              [showCloseButton]="true"
              (closeAl)="onAlertClose()"
            >
              <ul>
                <li *ngFor="let msg of submissionErrorObj">{{ msg.error | translate }}</li>
              </ul>
            </kt-alert>
            <div class="form-section form-section-first whole-form">
              <div class="form-group row cards-inside-doctor-form">
                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>{{ 'INSURANCE.INPUT.NAME' | translate }}</mat-label>
                    <input matInput formControlName="name" required />
                    <mat-error *ngIf="isControlHasError('name', 'required')">
                      {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>{{ 'INSURANCE.INPUT.INSURANCE_TYPE' | translate }}</mat-label>
                    <input matInput formControlName="insuranceType" required />
                    <mat-error *ngIf="isControlHasError('insuranceType', 'required')">
                      {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>{{ 'INSURANCE.INPUT.SUBMISSION_TYPE' | translate }}</mat-label>
                    <input matInput formControlName="submissionType" required />
                    <mat-error *ngIf="isControlHasError('submissionType', 'required')">
                      {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>{{ 'INSURANCE.INPUT.BIN' | translate }}</mat-label>
                    <input matInput formControlName="bin" required />
                    <mat-error *ngIf="isControlHasError('bin', 'required')">
                      {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>{{ 'INSURANCE.INPUT.PCN' | translate }}</mat-label>
                    <input matInput formControlName="pcn" />
                  </mat-form-field>
                </div>

                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>{{ 'INSURANCE.INPUT.PHONE' | translate }}</mat-label>

                    <input matInput formControlName="phone" maxlength="14" ktAppPhoneMask />

                    <mat-error
                      >{{ 'INSURANCE.INPUT.PHONE' | translate }}
                      {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                    </mat-error>
                    <mat-error *ngIf="isControlHasError('phone', 'pattern')">
                      {{ 'AUTH.VALIDATION.PATTERN' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</kt-portlet>
